<template>
  <div>
    <div v-if="loading" class="d-flex align-items-center justify-content-center">
      <i class="fas fa-spinner fa-spin text-primary p-5 fa-3x"></i>
    </div>
    <div v-else-if="step.name === 'server.create'">
      <ServerFormView :community-id="communityId" creating @create="step = { name: 'server.setup', server: $event.server }"/>
    </div>
    <div v-else-if="step.name === 'server.setup'">
      <ServerSetupView :server="step.server" @complete="step = { name: 'modules', reload: false }"/>
    </div>
    <div v-else-if="step.name === 'modules'">
      <HttpContentView :endpoint="utilities.path('communities/@/modules', communityId)" v-model:reload="step.reload">
        <template v-slot:content="{ data }">
          <div class="list-group">
            <HttpFormView v-for="item in data" :key="item.key" :endpoint="utilities.path('communities/@/modules/@', communityId, item.key)" method="put" @success="step.reload = true">
              <template v-slot:form="{ content, submit, loading }">
                <button class="list-group-item list-group-item-action" @click="content.enabled = !content.enabled; submit()" :disabled="loading || !item.available">
                  <div class="d-flex align-items-center justify-content-between g-4">
                    <div>
                      <div class="d-flex align-items-center justify-content-between g-3">
                        <h4 class="mb-0 d-flex align-items-center g-2">
                          <i :class="item.icon" class="fa-lg fa-fw"></i>
                          {{ item.name }}
                        </h4>
                      </div>
                      <div v-if="item.description.length > 0" class="text-muted mt-2" style="font-size: 0.9em">
                        {{ item.description }}
                      </div>
                    </div>
                    <CheckboxView :active="item.enabled" color="primary" class="large"/>
                  </div>
                </button>
              </template>
            </HttpFormView>
          </div>
          <ButtonView type="normal" color="primary" class="w-100 mt-4" @click="step = { name: 'frontend' }">
            {{ translate("continue") }}
          </ButtonView>
        </template>
      </HttpContentView>
    </div>
    <div v-else-if="step.name === 'frontend'">
      <HttpContentView :endpoint="utilities.path('communities/@', communityId)">
        <template v-slot:content="{ data }">
          <div class="d-flex align-items-center justify-content-center flex-column g-5">
            <div>
              {{ translate("community.setup.frontend.description") }}
            </div>
            <div class="p-3 rounded-4 bg-secondary">
              <a class="btn btn-link large btn-primary" :href="'https://' + (data.domain ?? data.subdomain)" target="_blank">
                <div class="d-flex align-items-center g-2">
                  <span>{{ data.subdomain }}</span>
                  <i class="fas fa-external-link"></i>
                </div>
              </a>
            </div>
            <ButtonView type="normal" color="primary" class="w-100 mt-4" @click="emit('complete')">
              {{ translate("complete") }}
            </ButtonView>
          </div>
        </template>
        <template v-slot:loading>
          <div class="d-flex align-items-center justify-content-center">
            <i class="fas fa-spinner fa-spin text-primary p-5 fa-3x"></i>
          </div>
        </template>
      </HttpContentView>
    </div>
  </div>
</template>

<script setup>
import {ButtonView, HttpContentView, CheckboxView, HttpFormView, utilities} from "@niftybit/vue";
import {onMounted, ref} from "vue";
import ServerFormView from "@/systems/community/views/ServerFormView.vue";
import ServerSetupView from "@/systems/community/views/ServerSetupView.vue";
import axios from "axios";
import info from "@/info";

const props = defineProps({
  communityId: String
});

const emit = defineEmits(["complete"]);

const step = ref({
  name: "server.create"
});

const loading = ref(true);

onMounted(() => {
  axios.get(utilities.path("communities/@/servers", props.communityId)).then(response => {
    if (response.data.data.length > 0) {
      step.value = {
        name: "modules"
      };
    }
  }).finally(() => {
    loading.value = false;
  });
});

</script>